export default __webpack_public_path__ + "static/media/ESG碳盤查.4bd83711.gif";